export default "__VITE_ASSET__3tuVwWzQ__"